import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seek-awareness',
  templateUrl: './awareness.component.html',
  styleUrls: ['./awareness.component.scss']
})
export class AwarenessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
